import React, { useState } from "react";
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const Card = () => {
  const [formData, setFormData] = useState({
    cardname: "",
    cardgroup: "",
    gamecategory: "",
    complexity: "",
    goal: "",
    age: "",
    difflevel:"",
    implementation:"",
  });
  const [grpsymbol, setGrpSymbol] = useState(null); // Separate state for the image

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("Updating field:", name, "to value:", value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setGrpSymbol(e.target.files[0]);
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("cardname", formData.cardname);
    data.append("cardgroup", formData.cardgroup);
    data.append("gamecategory", formData.gamecategory);
    data.append("complexity", formData.complexity);
    data.append("goal", formData.goal);
    data.append("age", formData.age);
    data.append("difflevel", formData.difflevel);
    data.append("implementation", formData.implementation);
    if (grpsymbol) {
      data.append("grpsymbol", grpsymbol); 
    }

    try {
      const response = await axios.post(API.POST_CARD_API, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          cardname: "",
          cardgroup: "",
          gamecategory: "",
          complexity: "",
          goal: "",
          age: "",
          difflevel:"",
          implementation:""
        });
        setGrpSymbol(null); 
        alert("Data submitted successfully!");
        navigate('/cardtable');
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="mt-4 w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Card Form
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="cardname" className="block text-sm font-medium text-gray-700 mb-1">
              Card Name
            </label>
            <input
              type="text"
              id="cardname"
              name="cardname"
              value={formData.cardname}
              onChange={handleChange}
              placeholder="Enter card name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="cardgroup" className="block text-sm font-medium text-gray-700 mb-1">
              Card Group
            </label>
            <input
              type="text"
              id="cardgroup"
              name="cardgroup"
              value={formData.cardgroup}
              onChange={handleChange}
              placeholder="Enter card group"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="gamecategory" className="block text-sm font-medium text-gray-700 mb-1">
              Game Category
            </label>
            <input
              type="text"
              id="gamecategory"
              name="gamecategory"
              value={formData.gamecategory}
              onChange={handleChange}
              placeholder="Enter game category"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="complexity" className="block text-sm font-medium text-gray-700 mb-1">
              Complexity
            </label>
            <input
              type="text"
              id="complexity"
              name="complexity"
              value={formData.complexity}
              onChange={handleChange}
              placeholder="Enter complexity"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="grpsymbol" className="block text-sm font-medium text-gray-700 mb-1">
              Group Symbol (Image)
            </label>
            <input
              type="file"
              id="grpsymbol"
              name="grpsymbol"
              onChange={handleFileChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="goal" className="block text-sm font-medium text-gray-700 mb-1">
              Goal
            </label>
            <input
              type="text"
              id="goal"
              name="goal"
              value={formData.goal}
              onChange={handleChange}
              placeholder="Goal"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="age" className="block text-sm font-medium text-gray-700 mb-1">
              Age Group
            </label>
            <input
              type="text"
              id="age"
              name="age"
              value={formData.age}
              onChange={handleChange}
              placeholder="Enter age"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="difflevel" className="block text-sm font-medium text-gray-700 mb-1">
              Difficulty Level
            </label>
            <input
              type="text"
              id="difflevel"
              name="difflevel"
              value={formData.difflevel}
              onChange={handleChange}
              placeholder="Enter dificulty level"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="implementation" className="block text-sm font-medium text-gray-700 mb-1">
              Implementation
            </label>
            <input
              type="text"
              id="implementation"
              name="implementation"
              value={formData.implementation}
              onChange={handleChange}
              placeholder="Enter Implementation"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Card;
